/*
 * promo-cupom-copy.js
 * Botão "copiar cupom" compartilhado pela section da page de promo e pelo selo da PDP.
 *
 * Contrato de DOM:
 *   [data-copy-root]                  wrapper do cupom
 *     [data-copy-code="CODIGO"]       elemento com o código (usa o atributo; fallback textContent)
 *     [data-copy-btn]                 botão; opcional data-copied-label="Copiado!"
 *
 * Delegação no document → funciona com múltiplas sections e conteúdo injetado.
 */
(function () {
  'use strict';

  if (window.__promoCupomCopyBound) return;
  window.__promoCupomCopyBound = true;

  function fallbackCopy(text) {
    return new Promise(function (resolve) {
      var ta = document.createElement('textarea');
      ta.value = text;
      ta.style.position = 'fixed';
      ta.style.opacity = '0';
      document.body.appendChild(ta);
      ta.select();
      try { document.execCommand('copy'); } catch (e) {}
      document.body.removeChild(ta);
      resolve();
    });
  }

  function copyText(text) {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      return navigator.clipboard.writeText(text).catch(function () { return fallbackCopy(text); });
    }
    return fallbackCopy(text);
  }

  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-copy-btn]');
    if (!btn) return;

    var root = btn.closest('[data-copy-root]');
    if (!root) return;

    var codeEl = root.querySelector('[data-copy-code]');
    if (!codeEl) return;

    var code = codeEl.getAttribute('data-copy-code') || codeEl.textContent;
    if (!code) return;

    if (btn.dataset.copyBusy === '1') return;
    btn.dataset.copyBusy = '1';

    var original = btn.textContent;
    var copiedLabel = btn.getAttribute('data-copied-label') || 'Copiado!';

    copyText(code).then(function () {
      btn.textContent = copiedLabel;
      setTimeout(function () {
        btn.textContent = original;
        btn.dataset.copyBusy = '0';
      }, 1800);
    });
  });
})();
